<template>
  <div class="add-post">
    <div class="upload-title">
      <input type="text" v-model="subjectName" placeholder="填写标题,会有更多点赞哦~" class="input-title">
    </div>
    <!-- maxlength="50" -->
    <!-- <van-field v-model="content" rows="6" autosize type="textarea" placeholder="请输入内容" show-word-limit /> -->
    <quill-editor v-model="content" :options="editorOption"></quill-editor>
    <van-field readonly clickable name="picker" class="field-color" :value="liveValue" label="关联直播"
      placeholder="点击选择直播预告" @click="showPicker = true" />
    <van-popup v-model="showPicker" position="bottom">
      <van-picker show-toolbar title="选择直播预告" :columns="columns" @confirm="onConfirm" @cancel="showPicker = false" />
    </van-popup>
    <div class="fixed-btn" :class="{cur: allInput, upload: uploadPost }" @click="handleAddPost">发布</div>
  </div>
</template>
<script>
import { addPost, getMmeeting, postDetails, updatePost } from '@/api/zone'
import { liveStatus, toolbarOptions, roleIsConsumer, roleIsTutor, rolesClick } from './data'
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  components: {
    quillEditor
  },
  data () {
    return {
      fileList: [],
      maxCount: 9,
      content: '',
      subjectName: '',
      form: {},
      areaId: '', // 专区Id
      fileIds: [],
      liveValue: '',
      columns: [],
      showPicker: false,
      liveList: [],
      dccId: '',
      editorOption: {
        modules: {
          toolbar: toolbarOptions
        },
        theme: 'snow',
        placeholder: '请输入内容...'
      },
      uploadPost: false,
      contentMaxLength: 1000
    }
  },
  computed: {
    allInput () {
      return this.subjectName.length > 0 && this.content.length > 0 && this.liveValue.length > 0
    },
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  created () {
    let role = JSON.parse(sessionStorage.getItem('roleResult'))
    if (roleIsConsumer(role, this.userInfo) || rolesClick(role, this.userInfo) || roleIsTutor(role, this.userInfo)) {
      this.$router.push({
        path: `/zoneDetails?areaId=${this.$route.query.areaId}`
      })
      return
    }
    this.areaId = this.$route.query.areaId
    this.dccId = this.$route.query.dccId

    if (this.dccId) {
      postDetails({ postbarId: this.dccId }).then(res => {
        this.areaId = res.data.areaId
        this.subjectName = res.data.subjectName
        this.content = res.data.content
        this.liveValue = `${res.data.liveDTO.liveTitle} - ${res.data.liveDTO.liveStaut}`
        this.handleFun()
      })
    } else {
      this.handleFun()
    }
  },
  methods: {
    getPlainTextLen(richText) {
      return richText
        .replace(/<[^>]+>/g, '')
        .replace(/ |\n|\r\n|&nbsp;|&ensp;/g, '')
        .replace(/[a-zA-Z]&#7([6-7][0-9]);/g, ' ')
        .replace(/&([a-z]{2,5}|#[0-9]{1,6});/g, ' ')
        .length
    },
    handleAddPost () {
      if (!this.allInput) {
        this.$toast('请输入内容')
        return
      }
      if (this.getPlainTextLen(this.content) > this.contentMaxLength) {
        this.$toast('字数超过1000！')
        return
      }
      if (this.uploadPost) return
      this.uploadPost = true
      let liveInfo = {}
      this.liveList.map(res => {
        if (`${res.meetingName} - ${liveStatus[res.meetingStatus]}` === this.liveValue) {
          liveInfo = {
            liveId: res.meetingLink,
            liveTitle: res.meetingName,
            liveCover: res.iliveCoverLink ? res.iliveCoverLink : res.zoomCoverPics ? res.zoomCoverPics[0].url : '',
            liveStartTime: res.startTime,
            liveEndTime: res.endTime,
            type: res.meetingType
          }
        }
      })
      let params = {
        id: this.dccId,
        areaId: this.areaId,
        // 1发帖2投票3直播预估4代办任务(作业)
        type: '3',
        userId: this.userInfo.id,
        subjectName: this.subjectName,
        content: this.content,
        // kind: 类别1RTC2病例交流3心电图交流)
        kind: '1',
        liveInfo
      }
      console.log(params)
      if (params.id) {
        delete params.kind
        updatePost(params).then(res => {
          this.$toast('发布成功')
          this.subjectName = ''
          this.content = ''
          this.liveValue = ''
          setTimeout(() => {
            this.$router.push({
              path: `/dcc?status=0`
            })
          }, 1500)
        }).catch((err) => {
          this.$toast(err.msg)
          this.uploadPost = false
        })
      } else {
        addPost(params).then(res => {
          this.$toast('发布成功')
          this.subjectName = ''
          this.content = ''
          this.liveValue = ''
          setTimeout(() => {
            this.$router.push({
              path: `/zoneDetails?areaId=${this.areaId}`
            })
          }, 1500)
        }).catch((err) => {
          this.$toast(err.msg)
          this.uploadPost = false
        })
      }
    },
    handleFun () {
      getMmeeting({
        pageNum: 1,
        pageSize: 100,
        areaId: this.areaId
      }).then(res => {
        const data = res.data.list
        this.liveList = data
        this.columns = data.map(item => `${item.meetingName} - ${liveStatus[item.meetingStatus]}`)
      })
    },
    onConfirm (value) {
      console.log(value)
      this.liveValue = value
      this.showPicker = false
    },
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.add-post {
padding-bottom: 90px;
box-sizing: border-box;
  .upload-imgs {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 16px 14px;
    box-sizing: border-box;

    /deep/ .van-uploader__wrapper {
      .van-uploader__preview,
      .van-image,
      .van-uploader__upload {
        width: 109px;
        height: 109px;
        margin-right: 10px;

        &:nth-child(3n) {
          margin-right: 0;
        }
      }

      .van-uploader__upload-icon {
        font-size: 36px;
      }
    }
  }

  .upload-title {
    width: 100%;
    border-top: 1px solid #E8E8E8;
    box-sizing: border-box;
    padding: 0 14px;
    box-sizing: border-box;

    .input-title {
      line-height: 55px;
      height: 55px;
      border: none;
      border-bottom: 1px solid #E8E8E8;
      font-weight: 600;
      outline: none;
      background-color: transparent;
      width: 100%;
      font-size: 18px;
      color: #282828;

      &::placeholder {
        color: #C0C0C2;
      }
    }
  }

  /deep/ .van-field__control {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.80);

    &::placeholder {
      color: #C0C0C2;
    }
  }

  .field-color {
    position: fixed;
    bottom: 90px;
    width: 348px;
    left: 50%;
    transform: translateX(-50%);
    padding-left: 0;
    padding-right: 0;

    &::before {
      border-top: 1px solid #ebedf0;
      content: "";
      position: absolute;
      box-sizing: border-box;
      pointer-events: none;
      top: 0;
      left: 0;
      right: 0;
      -webkit-transform: scaleY(.5);
      transform: scaleY(.5);
    }

    &::after {
      left: 0;
      right: 0;
    }

    /deep/ .van-field__control {
      color: #EB1700;
      text-align: right;
    }
  }

  .fixed-btn {
    position: fixed;
    bottom: 24px;
    left: 14px;
    width: calc(100vw - 28px);
    height: 42px;
    border-radius: 100px;
    background-color: #E6E6E6;
    font-size: 16px;
    color: #AEAEAE;
    text-align: center;
    line-height: 42px;
    font-weight: 500;

    &.cur {
      color: #fff;
      background-color: #EB1700;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/RTCZone/livePreview.vue